import { overflow } from "@prismicio/editor-support/String"
import { SelectItem, Text } from "@prismicio/editor-ui"
import { useCallback, useEffect } from "react"

import { useRequestRepositoryTags } from "../../../hooks/useRequestRepositoryTags"
import { useAPIExplorer } from "../../APIExplorerContext"
import { RequestFormInput } from "./RequestFormInput"
import { RequestFormSelect } from "./RequestFormSelect"

/**
 * Display a fieldset managing a request tag settings.
 */
export function RequestTagFieldset() {
  const { request } = useAPIExplorer()
  const tags = useRequestRepositoryTags()

  const setTag = useCallback(
    (tag: string) => {
      request.setRequestOptions(request.type, {
        ...request.options[request.type],
        tag,
      })
    },
    [request],
  )

  useEffect(() => {
    if (tags && !request.options[request.type]?.["tag"] && tags[0]) {
      setTag(tags[0])
    }
  }, [request.options, request.type, tags, setTag])

  if (!tags || !tags.length) {
    return (
      <RequestTagFieldsetFreeForm
        tag={request.options[request.type]?.tag ?? ""}
        setTag={setTag}
      />
    )
  }

  const selectedTag = request.options[request.type]?.tag ?? ""
  const unknownTag =
    selectedTag && !tags.includes(selectedTag) ? selectedTag : undefined

  return (
    <RequestFormSelect
      label="TAG *"
      value={selectedTag}
      onValueChange={setTag}
      placeholder="design"
    >
      {unknownTag && (
        <SelectItem key={unknownTag} value={unknownTag}>
          <Text component="span" color="tomato11" noWrap>
            {overflow(unknownTag, 32)} (not in repository)
          </Text>
        </SelectItem>
      )}
      {tags.map((tag) => (
        <SelectItem key={tag} value={tag}>
          {overflow(tag, 32)}
        </SelectItem>
      ))}
    </RequestFormSelect>
  )
}

interface RequestTagFieldsetFreeFormProps {
  tag: string
  setTag: (tag: string) => void
}

function RequestTagFieldsetFreeForm(props: RequestTagFieldsetFreeFormProps) {
  const { tag, setTag } = props

  return (
    <RequestFormInput
      value={tag}
      onValueChange={setTag}
      label="TAG *"
      placeholder="design"
    />
  )
}
